export default "__VITE_ASSET__wtldsGi2__"